import *  as axios from 'axios';
import * as R from 'ramda';
import * as ActionTypes from '../../constants/actiontypes/funecap/dossiers';
import * as urls from '../../constants/webapi/backoffice/dossiers';
import { getAuthenticationUrl } from '../../constants/webapi/auth';

export function fetchUsers(role, pageNumber, search, partnerId = "", type, sortBy, sortDesc, creationUser = "", status = "", fromCreationDate = "", toCreationDate = "") {
	const page = parseInt(pageNumber);
	if (!R.isNil(pageNumber) && isNaN(page)) {
		throw new Error("pageNumber must be null or an integer");
	}

	return (dispatch) => {
		dispatch({ type: ActionTypes.FETCH_USERS_DOSSIERS_REQUEST, role: role });
		return axios
			.get(urls.usersByRoleUrl(role, pageNumber, search, partnerId, type, sortBy, sortDesc, creationUser, status === "all" ? "" : status, fromCreationDate, toCreationDate))
			.then((response) => {
				dispatch({
					type: ActionTypes.FETCH_USERS_DOSSIERS_SUCCESS,
					data: response.data,
				});
			})
			.catch((error) => {
				if (error.response !== undefined && error.response.status === 401) {
					window.location = getAuthenticationUrl();
					return;
				}
				dispatch({
					type: ActionTypes.FETCH_USERS_DOSSIERS_FAILURE,
					response: error.response,
				});
				throw error.statusText;
			});
	};
}

export function UpdateUserCreation(userId, creationUserId) {
    return (dispatch) => {
        dispatch({ type: ActionTypes.UPDATE_USERCREATION_REQUEST });
        return axios.put(urls.userCreationUpdate(userId), { UserCreationId: creationUserId})
            .then((response) => {
                dispatch({
                    type: ActionTypes.UPDATE_USERCREATION_SUCCESS,
                    data: response.data
                });
            })
            .catch((error) => {
                if (error.response !== undefined && error.response.status === 401) {
                    window.location = getAuthenticationUrl();
                    return;
                }
                dispatch({
                    type: ActionTypes.UPDATE_USERCREATION_FAILURE,
                    response: error.response
                });
                throw error.statusText;
            });
    };
}
